import { Auth } from 'aws-amplify'

import { CognitoUser } from '.'
import { SignInFormValues } from '@util/cognito-forms'
import { amplifyConfiguration } from './amplifyConfiguration'

/**
 * @param formValues {ISignInFormValues}
 * @param fromSignUp {Boolean} — signIn() will be called from signUp() to complete
 * user Authentication — Amplify's signIn() call NEEDS to be called for properly
 * reflect user auth status across its methods
 */
export async function signIn(
  formValues: SignInFormValues
): Promise<CognitoUser> {
  const { email, password } = formValues

  // mock the sign-in portion for Cypress
  if (window.Cypress) {
    const AuthMocked = await import(
      '@util/amplify-mock-implementations/mocked-cognito-api'
    )
    return AuthMocked.default.signIn(email)
  }

  if (!amplifyConfiguration.isConfigured) {
    await amplifyConfiguration.configureViaEmail(email)
  }

  /**
   * the final step for Amplify to treat a user as auth'd. this allows Thrive's
   * platform API requests to ultimately procure an auth token via Amplify
   */
  const user = await Auth.signIn(email, password)
  return user
}
